var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpecializedExchange = function SvgSpecializedExchange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none",
    viewBox: "0 0 19 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.58 15.94a1 1 0 0 0 1.16 0l6.98-5a1 1 0 0 0 .37-1.13L14.43 1.7a1 1 0 0 0-.95-.69H4.84a1 1 0 0 0-.95.69L1.23 9.8a1 1 0 0 0 .37 1.13l6.98 5Z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgSpecializedExchange;